<div class="footer-copyright">
  &copy; {{ copyrightYear }} Zethcon Corporation
</div>
